import React from 'react';
import { Box, List, Stack, Typography, useMediaQuery } from '@mui/material';
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import usePageMenuDrawer from './usePageMenuDrawer';
const PAGE_MENU_DRAWER_WIDTH = 170;
const openedMixin = (theme) => ({
    width: PAGE_MENU_DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});
const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(7)} + 1px)`,
    },
});
const Drawer = styled(MuiSwipeableDrawer)(({ theme, open }) => ({
    width: PAGE_MENU_DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));
const Nav = styled(List)({
    '& .MuiListItemIcon-root': {
        minWidth: 0,
        marginRight: 16,
    },
});
function PageHeaderDrawer({ menu }) {
    const theme = useTheme();
    const { open, close, isOpen } = usePageMenuDrawer();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    if (!open || !close) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Drawer, { onClose: close, onOpen: open, variant: isBigScreen ? 'permanent' : 'temporary', open: isOpen, sx: {
            '& .MuiDrawer-paper': {
                top: 52,
                height: 'auto',
                bottom: 4,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
            },
        } },
        React.createElement(Nav, { dense: true, sx: { display: 'flex', flexDirection: 'column' } }, menu),
        React.createElement(Box, { sx: { flex: 1 } }),
        React.createElement(Stack, { gap: 1 },
            isOpen ? (React.createElement(Typography, { variant: "caption", sx: {
                    wordBreak: 'break-word',
                    wordWrap: 'break-word',
                    whiteSpace: 'break-spaces',
                    textAlign: 'center',
                } }, "*Centralized Operating System for Managing Open Sky")) : null,
            React.createElement(Typography, { variant: "caption", sx: {
                    wordBreak: 'break-word',
                    wordWrap: 'break-word',
                    whiteSpace: 'break-spaces',
                    textAlign: 'center',
                } }, "\u00A9 Wheeebo"))));
}
export default React.memo(PageHeaderDrawer);
export { PAGE_MENU_DRAWER_WIDTH };
